import { Injectable } from '@angular/core';
import { Listing } from '@df/catalog-ui/listing/listing';
import { ISortOptions } from '@df/catalog-ui/listing/sort/abstract-async.engine';
import { Product } from '@df/catalog/product/product';
import { ListingSortKlevuEngine } from '@df/module-klevu-search/listing-sort-klevu.engine';
import intersection from 'lodash-es/intersection';

@Injectable({
    providedIn: 'root'
})
export class ListingSortKlevuEngineDecorator extends ListingSortKlevuEngine {
    protected override getSortOptions(listing: Listing<Product>): ISortOptions {
        const sortOptions = super.getSortOptions(listing);

        if (listing.config.source.data.heroProducts?.length) {
            sortOptions.bannerPositionsUnchanged = false;
        }

        return sortOptions;
    }

    protected override runCallback(listing: Listing<Product>, cb: (err: Error | string | null, ids: number[]) => void, ids?: number[]) {
        const heroProducts = listing.config.source.data.heroProducts || [];
        if (!ids?.length && listing?.config?.source?.data?.products?.length) {
            ids = listing.config.source.data.products;
        } else if (ids?.length && listing?.config?.source?.data?.products?.length) {
            ids = intersection(ids, listing?.config?.source?.data?.products);
        }
        if (heroProducts.length) {
            // push hero products to the bottom before setting up their final position,
            // its needed because otherwise we can remove products form top after setting other hero position and breaking the order this way
            ids = ids?.sort((a, b) => {
                if (heroProducts.find(i => i.product_id === a)) return 1;
                if (heroProducts.find(i => i.product_id === b)) return -1;
                return 0;
            });
        }

        heroProducts.forEach(heroProduct => {
            const matchingProduct = ids?.find(id => id === heroProduct.product_id);
            if (matchingProduct) {
                const insertIndex = heroProduct.position - 1;
                ids?.splice(ids?.indexOf(matchingProduct), 1);
                ids?.splice(insertIndex, 0, matchingProduct);
            } else {
                ids?.splice(heroProduct.position - 1, 0, heroProduct.product_id);
            }
        });
        super.runCallback(listing, cb, ids);
    }
}
